import type { ProblemCategory, ProblemCategoryList } from '@shared/types/problem-category';
import { api } from './client';

/// 課題カテゴリマスタの読み取り / 追加。 課題の作成/詳細編集と一覧フィルタで
/// 選択肢候補に使う。
export const problemCategoriesApi = {
  list(): Promise<ProblemCategoryList> {
    return api.get<ProblemCategoryList>('/api/problem-categories');
  },
  /// 新規カテゴリを追加する。 sort_order は backend が採番するため送らない。
  create(name: string): Promise<ProblemCategory> {
    return api.post<ProblemCategory>('/api/problem-categories', { name });
  },
};
